import { render, staticRenderFns } from "./ConsumableCard.vue?vue&type=template&id=543222a5&scoped=true&"
import script from "./ConsumableCard.vue?vue&type=script&lang=ts&"
export * from "./ConsumableCard.vue?vue&type=script&lang=ts&"
import style0 from "./ConsumableCard.vue?vue&type=style&index=0&id=543222a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543222a5",
  null
  
)

export default component.exports